 import React from "react";
 import styles from "../styles/Typography.module.css";
 
 export default function AdminLineItem({ title, children, user, className = "" }) {
    return (
        <>
   
          <div
            style={{
              backgroundColor: "#fff",
              color: "var(--bs-dark)",
              marginBottom: "2rem",
              borderRadius: "8px",
              textAlign: "center",
              margin: "0 auto",
              width: "100%",
              paddingBottom: "8rem",
              paddingTop: "1rem",
            }}
          >{children}
            </div>
        </>
    );
 }
